exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#advisor-dashboard-container{padding:25px}.advisor-close{padding:24px !important}.sidebar-open{margin-left:250px}.sidebar-close{margin-left:72px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Layout/Layout.scss
// module id = 1118
// module chunks = 115